
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/runner/work/baserow-zh-build/baserow-zh-build/src/web-frontend/sentry.client.config.ts")
            }
          });